<template>
  <div class="home">
    <div class="container">
      <div class="box">
        <h1 class="text">hopnami</h1>
      </div>
      <div class="social">
        <template v-for="value in social">
          <a
            class="social-link"
            v-if="value.display"
            :key="value.id"
            :href="value.url"
            :aria-title="value.title"
            :title="value.title"
            rel="nofollow"
            target="_blank"
          >
            <div
              class="live"
              v-if="
                (value.name === 'twitch' && isLiveOnTwitch) ||
                  (value.name === 'mixer' && isLiveOnMixer)
              "
            />
            <Icon class="icon" :glyph="value.name" />
            <template
              v-if="
                (value.name === 'twitch' && isLiveOnTwitch) ||
                  (value.name === 'mixer' && isLiveOnMixer)
              "
            >
              <div class="live-tooltip">Live</div>
            </template>
          </a>
        </template>
      </div>
    </div>
    <Modal>
      <gear-list />
    </Modal>
  </div>
</template>

<script>
import stream from '@/stream';
import { Modal, Gear, Icon, Mixer, Twitch } from '@/components';
export default {
  name: 'home',
  components: {
    Modal,
    Icon,
    Mixer,
    Twitch,
    'gear-list': Gear
  },
  computed: {
    isLiveOnMixer() {
      return this.$store.state.mixerLiveStatus;
    },
    isLiveOnTwitch() {
      return this.$store.state.twitchLiveStatus;
    }
  },
  data() {
    return {
      social: [
        {
          display: false,
          name: 'facebook',
          title: 'Follow me on Facebook',
          url: 'https://www.facebook.com/hopnami'
        },
        {
          display: true,
          name: 'twitter',
          title: 'Follow me on Twitter',
          url: 'https://www.twitter.com/hopnami_'
        },
        {
          display: true,
          name: 'instagram',
          title: 'Follow me on Instagram',
          url: 'https://www.instagram.com/hopnami'
        },
        {
          display: true,
          name: 'steam',
          title: 'Add me on Steam!',
          url: 'https://steamcommunity.com/id/hopnami'
        },
        {
          display: true,
          name: 'twitch',
          title: `Follow ${stream.twitch.name} on Twitch`,
          url: `https://www.twitch.com/${stream.twitch.name}`
        },
        {
          display: true,
          name: 'mixer',
          title: `Follow ${stream.mixer.name} on Mixer`,
          url: `https://www.mixer.com/${stream.mixer.name}`
        },
        {
          display: false,
          name: 'discord',
          title: 'Join the Discord!',
          url: 'https://www.discord.gg/'
        }
      ]
    };
  },

  methods: {
    toggleTooltip() {
      this.displayTooltip = !this.displayTooltip;
      console.log('hov');
    }
  }
};
</script>

<style lang="scss" scoped>
$gradient: linear-gradient(to top right, #76adfe, #f0818c);
.home {
  // background-attachment: fixed;
  // background-image: radial-gradient(circle, #0d274f, #212121);
  // height: 100%;
  // overflow: auto;
  // position: fixed;
  // width: 100%;
}

.landing {
  position: relative;
  z-index: 10;
}

.container {
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}

.box {
  align-items: center;
  border: 0.5em solid;
  border-image-source: $gradient;
  border-image-slice: 1;
  display: flex;
  justify-content: center;
  padding: 2em;
}

.text {
  background-image: $gradient;
  font: {
    family: 'Staatliches', sans-serif;
    size: 2.4rem;
    // weight: 800;
  }
  letter-spacing: 0.2em;
  text-transform: uppercase;
  line-height: 1.2;
  position: relative;
  text-align: center;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  z-index: 30;
}

.social {
  align-items: center;
  display: flex;
  // justify-content: space-around;
  justify-content: center;
  margin-top: 15px;
  color: #fff;
  text-align: center;
}

.social-link {
  flex: 0 1 auto;
  height: 36px;
  margin-left: 3px;
  margin-right: 3px;
  padding: 3px;
  width: 36px;
  transition: 150ms ease;
  transform: translate3d(0, 0, 0);

  .no-touch &:hover .icon {
    animation-name: bounce;
    animation-duration: 750ms;
    animation-fill-mode: both;
    opacity: 1;
  }
}

.live {
  background-color: red;
  border-radius: 50%;
  height: 6px;
  left: 0;
  margin-left: auto;
  margin-right: auto;
  position: absolute;
  right: 0;
  top: 100%;
  width: 6px;
  z-index: 10;
}

.live-tooltip {
  background-color: rgba(#000, 0.24);
  border-radius: 18px;
  color: #fff;
  font-size: 10px;
  font-weight: 500;
  line-height: 1.2;
  margin-left: auto;
  margin-right: auto;
  padding: 3px 6px;
  position: absolute;
  left: 50%;
  letter-spacing: 0.7px;
  margin-top: 10px;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  top: 100%;
  transform: translateX(-50%);
  white-space: nowrap;
}

.icon {
  transform-origin: center bottom;
  transition: 150ms ease;
  fill: #fff;
  height: 100%;
  opacity: 0.5;

  width: 100%;
}

@keyframes scale {
  0% {
    transform: scale(0.9);
  }
  70% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes bounce {
  from,
  20%,
  53%,
  80%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0);
  }

  40%,
  43% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -15px, 0);
  }

  70% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -9px, 0);
  }

  90% {
    transform: translate3d(0, -3px, 0);
  }
}
</style>
